// Admin-only per-key descriptions for account client config. Env-independent.
// NOT persisted to KV/D1 and NOT read by runtime code — shown in the admin config table.
export const clientDescription = {
    commonMinHeight: 'common content min height (px)',
};
